module.exports = __webpack_public_path__ + "static/media/BSC_wtag_541blue.54b4adb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/BSC_wtag_541blue.png
// module id = 1374
// module chunks = 0